var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.477,
    height: 12.875
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31376",
    d: "M8.25 7.243a1.359 1.359 0 00.922-.469L15.61.399a2.214 2.214 0 00-1.516-.4H2.187A1.884 1.884 0 00.859.366l6.469 6.408a1.339 1.339 0 00.922.469zM.195 11.649L5.469 6.43.196 1.23a2.394 2.394 0 00-.2 1.133v8.153a2.394 2.394 0 00.199 1.133zm2.188 1.226h11.906a1.948 1.948 0 001.344-.367l-5.375-5.32-.469.469a2.231 2.231 0 01-1.539.719 2.231 2.231 0 01-1.539-.719l-.477-.469L.875 12.5a2.338 2.338 0 001.508.375zm13.914-1.234a2.552 2.552 0 00.18-1.125V2.36a2.435 2.435 0 00-.187-1.117L11.031 6.43z",
    fill: "#5f48e9"
  })));
}

export default SvgMessageBlue;